import { useState } from 'react';
import Api from '@/api/api';
import { showToast } from '@/components/ToastManager';
import { useBoardPdfStore } from '@/stores/boardPdf';
import { useSend } from '@/components/SendProvider';

export const useMeetingFileUpload = (meetingUid: string | undefined) => {
  const [hover, setHover] = useState(false);
  const { setActiveDoc } = useBoardPdfStore();
  const { addUploadDoc, uploadDocs } = useBoardPdfStore();
  const { sendUploadFiles } = useSend();

  const handleFile = async (
    event: React.ChangeEvent<HTMLInputElement> | React.DragEvent<HTMLElement>
  ) => {
    let file;
    if ('dataTransfer' in event) {
      event.preventDefault();
      event.stopPropagation();
      setHover(false);
      file = event.dataTransfer?.files?.[0];
    } else {
      file = (event.target as HTMLInputElement).files?.[0];
    }

    if (!file || !meetingUid) {
      return;
    }

    if (uploadDocs.length >= 5) {
      showToast(
        'errorToast',
        'error',
        'Ошибка загрузки файла',
        'Превышен лимит: до 5 загружаемых файлов'
      );
      return;
    }

    if (file.type !== 'application/pdf') {
      showToast(
        'errorToast',
        'error',
        'Ошибка загрузки файла',
        'Неверный формат файла. Загрузите файл в формате pdf'
      );
      return;
    }

    const maxSizeInBytes = 5 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      showToast(
        'errorToast',
        'error',
        'Ошибка загрузки файла',
        'Превышен размер файла > 5 Мб. Выберите другой файл'
      );
      return;
    }

    try {
      const doc = await Api.uploadMeetingPdf(meetingUid, file);
      addUploadDoc(doc);
      setActiveDoc({ id: doc.id, path: doc.path });
      const message = { action: 'file-add', file: { path: doc.path, id: doc.id } };
      await sendUploadFiles(new TextEncoder().encode(JSON.stringify(message)), {
        reliable: true
      });
    } catch (err) {
      console.error(err);
      showToast(
        'errorToast',
        'error',
        'Ошибка загрузки файла',
        'Не удалось загрузить файл. Попробуйте позже'
      );
      return;
    }
  };

  return { handleFile, hover, setHover };
};
